/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Logo from "./../../../assets/Jobvious_logo.png";
import { ForgotPassword } from "aws-amplify-react";
import { Auth } from "aws-amplify";
import { normalizeEmail } from "../../../util/userIdentity";

export class CustomForgotPassword extends ForgotPassword {
  constructor(props) {
    super(props);
    this._validAuthStates = ["forgotPassword"];
    this.state = {
      username: "",
      code: "",
      password: "",
      delivery: null, // null = request code, object = enter code
      error: null,
      loading: false
    };
  }

  // Cognito usernames are always lowercase — lowercase as typed.
  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value.toLowerCase(), error: null });
  };

  handleCodeChange = (e) => {
    this.setState({ code: e.target.value, error: null });
  };

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value, error: null });
  };

  // Step 1: Send verification code
  sendCode = async () => {
    const username = normalizeEmail(this.state.username);

    if (!username) {
      this.setState({ error: "Please enter your email address" });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const data = await Auth.forgotPassword(username);
      this.setState({
        delivery: data.CodeDeliveryDetails,
        loading: false
      });
    } catch (err) {
      console.error("Error sending code:", err);
      this.setState({
        error: err.message || "Failed to send verification code. Please try again.",
        loading: false
      });
    }
  };

  // Step 2: Submit new password with code
  submitNewPassword = async () => {
    const { code, password } = this.state;
    const username = normalizeEmail(this.state.username);

    if (!code) {
      this.setState({ error: "Please enter the verification code" });
      return;
    }

    if (!password) {
      this.setState({ error: "Please enter a new password" });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      await Auth.forgotPasswordSubmit(username, code, password);
      // Success - go back to sign in
      this.changeState("signIn");
    } catch (err) {
      console.error("Error resetting password:", err);
      this.setState({
        error: err.message || "Failed to reset password. Please try again.",
        loading: false
      });
    }
  };

  // Go back to request code step
  resendCode = async () => {
    this.setState({ delivery: null, code: "", password: "", error: null });
  };

  // Go back to sign in
  backToSignIn = () => {
    this.changeState("signIn");
  };

  showComponent(theme) {
    const { username, code, password, delivery, error, loading } = this.state;

    // Step 2: Enter verification code and new password
    if (delivery) {
      return (
        <div className="App">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="content p-5">
                  <div className="row justify-content-md-center">
                    <div className="card col-lg-4 p5-lg">
                      <div className="card-body">
                        <h5 className="card-title text-center mb-5">
                          <img src={Logo} alt="" />
                        </h5>
                        <h6 className="card-subtitle mb-2 text-muted text-center">
                          Reset Your Password
                        </h6>
                        <p className="text-center text-muted small mb-4">
                          We sent a verification code to{" "}
                          <strong>{delivery.Destination}</strong>
                        </p>

                        {error && (
                          <div className="alert alert-danger" role="alert">
                            {error}
                          </div>
                        )}

                        {/* Form */}
                        <form>
                          <div className="form-group">
                            <label className="font-bold" htmlFor="code">
                              Verification Code
                            </label>
                            <input
                              className="form-control"
                              id="code"
                              name="code"
                              type="text"
                              value={code}
                              onChange={this.handleCodeChange}
                              autoComplete="one-time-code"
                              autoFocus
                              placeholder="Enter the code from your email"
                            />
                          </div>
                          <div className="form-group">
                            <label className="font-bold" htmlFor="new-password">
                              New Password
                            </label>
                            <input
                              className="form-control"
                              id="new-password"
                              name="password"
                              type="password"
                              value={password}
                              onChange={this.handlePasswordChange}
                              autoComplete="new-password"
                              placeholder="Enter your new password"
                            />
                            <small className="form-text text-muted mt-2">
                              Password must be at least 8 characters
                            </small>
                          </div>
                          <div className="form-group">
                            <button
                              className="btn btn-outline-primary btn-block mb-3"
                              type="button"
                              onClick={this.submitNewPassword}
                              disabled={loading}
                            >
                              {loading ? "Resetting..." : "Reset Password"}
                            </button>
                          </div>
                        </form>
                        {/* End Form */}

                        {/* Divider */}
                        <hr />

                        {/* Back links */}
                        <div className="text-center mt-3">
                          <p>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.resendCode();
                              }}
                              style={{ textDecoration: "underline" }}
                            >
                              RESEND CODE
                            </a>
                            {" | "}
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.backToSignIn();
                              }}
                              style={{ textDecoration: "underline" }}
                            >
                              BACK TO SIGN IN
                            </a>
                          </p>
                        </div>

                        {/* Need help */}
                        <div className="text-center mt-3">
                          <p>
                            Need help?{" "}
                            <a href="mailto:support@jobvious.com?subject=Password%20Reset%20Assistance&body=Hi%20Jobvious%20Support%2C%0A%0AI%20need%20help%20resetting%20my%20password.%0A%0AThanks!">
                              Contact Support
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col text-center">
                    <p>&copy; 2026 Jobvious, Inc </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // Step 1: Request verification code
    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="content p-5">
                <div className="row justify-content-md-center">
                  <div className="card col-lg-4 p5-lg">
                    <div className="card-body">
                      <h5 className="card-title text-center mb-5">
                        <img src={Logo} alt="" />
                      </h5>
                      <h6 className="card-subtitle mb-2 text-muted text-center">
                        Reset Your Password
                      </h6>
                      <p className="text-center text-muted small mb-4">
                        Enter your email address and we'll send you a code to reset your password
                      </p>

                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}

                      {/* Form */}
                      <form>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="username">
                            Email
                          </label>
                          <input
                            className="form-control"
                            id="username"
                            name="username"
                            type="email"
                            value={username}
                            onChange={this.handleUsernameChange}
                            autoComplete="email"
                            autoFocus
                            placeholder="Enter your email address"
                          />
                        </div>
                        <div className="form-group">
                          <button
                            className="btn btn-outline-primary btn-block mb-3"
                            type="button"
                            onClick={this.sendCode}
                            disabled={loading}
                          >
                            {loading ? "Sending..." : "Send Reset Code"}
                          </button>
                        </div>
                      </form>
                      {/* End Form */}

                      {/* Divider */}
                      <hr />

                      {/* Back to Sign In */}
                      <div className="text-center mt-3">
                        <p>
                          Remember your password?{" "}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.backToSignIn();
                            }}
                            style={{ textDecoration: "underline" }}
                          >
                            BACK TO SIGN IN
                          </a>
                        </p>
                      </div>

                      {/* Need help */}
                      <div className="text-center mt-3">
                        <p>
                          Need help?{" "}
                          <a href="mailto:support@jobvious.com?subject=Password%20Reset%20Assistance&body=Hi%20Jobvious%20Support%2C%0A%0AI%20need%20help%20resetting%20my%20password.%0A%0AThanks!">
                            Contact Support
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col text-center">
                  <p>&copy; 2026 Jobvious, Inc </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomForgotPassword;
